import React from 'react';
import { Chip, alpha } from '@mui/material';
import FiberManualRecordRounded from '@mui/icons-material/FiberManualRecordRounded';

export type DataBadgeKind = 'real' | 'placeholder';

interface DataBadgeProps {
  kind: DataBadgeKind;
  label?: string;
}

/**
 * "Real data" vs "Placeholder" tag, matching the transparency convention from
 * the Dialing Performance product brief: every metric on screen is labeled
 * either calculated from real records, or shown as a dash pending missing
 * data — never silently omitted.
 */
export default function DataBadge({ kind, label }: DataBadgeProps) {
  const isReal = kind === 'real';
  return (
    <Chip
      size="small"
      icon={<FiberManualRecordRounded sx={{ fontSize: '8px !important' }} />}
      label={label ?? (isReal ? 'Real data' : 'Placeholder')}
      sx={(t) => ({
        height: 20,
        fontWeight: 700,
        fontSize: '10px',
        letterSpacing: '0.03em',
        textTransform: 'uppercase',
        border: 'none',
        bgcolor: isReal ? alpha(t.palette.success.main, 0.12) : alpha(t.palette.warning.main, 0.16),
        color: isReal ? t.palette.success.dark : t.palette.warning.dark,
        '& .MuiChip-label': { px: 0.75 },
        '& .MuiChip-icon': { color: 'inherit', ml: '7px', mr: '-4px' },
      })}
    />
  );
}
